module.exports = __webpack_public_path__ + "static/media/BrixSans-Medium.d1d6c6f6.eot";